import { useEffect, useRef, useState } from 'react';
const useIsScrollDown = () => {
    const [isScrollDown, setIsScrollDown] = useState(false);
    const viewportRef = useRef(null);
    useEffect(() => {
        const el = viewportRef.current;
        if (!el) {
            return () => { };
        }
        const handleScroll = () => {
            setIsScrollDown(el.scrollTop > 0);
        };
        handleScroll();
        el.addEventListener('scroll', handleScroll);
        return () => {
            el.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return { isScrollDown, viewportRef };
};
export { useIsScrollDown };
//# sourceMappingURL=useIsScrollDown.js.map